import axios from "axios"
import {MessageBox, Message} from "element-ui"
import store from "@/store"
import {getToken} from "@/utils/auth"

import qs from "qs"
// 正在进行中的请求列表
let reqList = []

/**
 * 阻止重复请求
 * @param {array} reqList - 请求缓存列表
 * @param {string} url - 当前请求地址
 * @param {function} cancel - 请求中断函数
 * @param {string} errorMessage - 请求中断时需要显示的错误信息
 */
const stopRepeatRequest = function (reqList, url, data, cancel, errorMessage) {
	const errorMsg = errorMessage || ""
	// console.log(reqList)
	for (let i = 0; i < reqList.length; i++) {
		if (reqList[i] === url) {
			cancel(errorMsg)
			return
		}
	}
	reqList.push(url)
}

/**
 * 允许某个请求可以继续进行
 * @param {array} reqList 全部请求列表
 * @param {string} url 请求地址
 */
const allowRequest = function (reqList, url) {
	for (let i = 0; i < reqList.length; i++) {
		if (reqList[i] === url) {
			reqList.splice(i, 1)
			break
		}
	}
}

const service = axios.create({
	headers: {
		"Access-Control-Allow-Origin": "*",
		"Access-Control-Allow-Credentials": true
	},
	baseURL: process.env.VUE_APP_SG_API,
	// baseURL: "http://localhost:61860", //开发时用
	// baseURL: "https://www.suguangkeji.com/OmsWebApi_Dev", //开发时用
	// baseURL:process.env.VUE_APP_BASE_API,
	timeout: 100000 // request timeout
})

// request interceptor
service.interceptors.request.use(
	(config) => {
		// do something before request is sent

		if (store.getters.token) {
			// let each request carry token
			// ['X-Token'] is a custom headers key
			// please modify it according to the actual situation
			// config.headers['sgtoken'] = getToken()
			config.headers["SgToken"] = getToken()
			// console.log(getToken())
		}
		let cancel
		// 设置cancelToken对象
		config.cancelToken = new axios.CancelToken(function (c) {
			cancel = c
		})
		// 阻止重复请求。当上个请求未完成时，相同的请求不会进行
		stopRepeatRequest(
			reqList,
			config.url,
			config?.data,
			cancel,
			`${config.url} 请求被中断`
		)

		return config
	},
	(error) => {
		// do something with request error
		console.log(error) // for debug
		return Promise.reject(error)
	}
)

// response interceptor
service.interceptors.response.use(
	/**
	 * If you want to get http information such as headers or status
	 * Please return  response => response
	 */

	/**
	 * Determine the request status by custom code
	 * Here is just an example
	 * You can also judge the status by HTTP Status Code
	 */
	(response) => {
		const {ResultCode, ResultMsg, Data} = response.data

		const res = {
			code: ResultCode,
			data: Data,
			message: ResultMsg
		}
		// console.log(res)
		// 增加延迟，相同请求不得在短时间内重复发送
		// setTimeout(() => {
		allowRequest(reqList, response.config.url)
		// }, 1000)
		// return response.data
		console.log()

		if (res.code == "E0403") {
			// router.push('/')
			// console.log(this)
			MessageBox.confirm("登录状态已过期，请重新登录", {
				confirmButtonText: "重新登录",
				cancelButtonText: "取消",
				type: "warning"
			})
				.then(() => {
					store.dispatch("user/resetToken").then(() => {
						location.reload()
					})
				})
				.catch(() => {
					this.$message({
						type: "info",
						message: "已取消"
					})
					// location.reload()
				})
		}
		if (res.code !== "I0001") {
			console.log(response)
			if (res.code == -2) {
				return Promise.reject(res)
			}
			// if (res.code !== 20000) {
			Message({
				message: res.message || "错误",
				type: "error",
				duration: 5 * 1000
			})

			// 50008: Illegal token; 50012: Other clients logged in; 50014: Token expired;
			if (res.code === 50008 || res.code === 50012 || res.code === 50014) {
				// to re-login
				MessageBox.confirm("该账号是否已在其他地方登录,是否退出", "确认退出", {
					confirmButtonText: "重新登录",
					cancelButtonText: "取消",
					type: "warning"
				}).then(() => {
					store.dispatch("user/resetToken").then(() => {
						location.reload()
					})
				})
			}
			if (res.code == "E0013") {
				return Promise.reject(res)
			}
			if (res.code) return Promise.reject(new Error(res.message || "错误"))
		} else {
			return res.data
			// return res
		}
	},
	(error) => {
		console.log(error) // for debug
		if (axios.isCancel(error)) {
			console.log(error.message)
		} else {
			// 增加延迟，相同请求不得在短时间内重复发送
			// setTimeout(() => {
			allowRequest(reqList, error.config.url)
			// }, 1000)
		}
		// Message({
		// 	message: error.ResultMsg,
		// 	type: "error",
		// 	duration: 5 * 1000
		// })

		return Promise.reject(error)
	}
)

export default service
